import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';
import { ReversarDistribucion} from './ReversarDistribucion.component';
import { RoleGuardService as RoleGuard } from '../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'ReversarDistribucion',
        component: ReversarDistribucion,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ReversarDistribucion'
        } 
    }
];

@NgModule({
    declarations: [
        ReversarDistribucion
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ReversarDistribucion
    ],
    bootstrap: [ReversarDistribucion]
})

export class ReversarDistribucionModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ReversarDistribucion/ReversarDistribucion.module.ts